import { css } from 'styled-components';
var reducedMotion = css(["@media (prefers-reduced-motion:reduce){animation:none;}"]);
export default reducedMotion;